module.exports = __webpack_public_path__ + "static/media/btn_arrow.8f4ff22e.svg";